import React from "react";
import { Link } from "react-router-dom";

const VARIANTS = {
  primary:
    "bg-accent-500 text-white hover:bg-accent-600 shadow-glow-accent focus-visible:outline-accent-500",
  secondary:
    "bg-brand-600 text-white hover:bg-brand-700 shadow-glow focus-visible:outline-brand-600",
  outline:
    "bg-transparent text-ink-800 border border-ink-200 hover:border-brand-600 hover:text-brand-600",
  ghost: "bg-transparent text-ink-600 hover:text-brand-600",
};

const SIZES = {
  md: "h-11 px-6 text-base",
  lg: "h-12 px-8 text-lg",
};

export default function Button({
  as,
  to,
  href,
  variant = "primary",
  size = "md",
  className = "",
  children,
  ...rest
}) {
  const classes = `inline-flex items-center justify-center gap-2 rounded-full font-semibold
    transition-colors duration-200 min-w-[44px]
    focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
    disabled:opacity-50 disabled:cursor-not-allowed
    ${VARIANTS[variant]} ${SIZES[size]} ${className}`;

  if (to) {
    return (
      <Link to={to} className={classes} {...rest}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={classes} {...rest}>
        {children}
      </a>
    );
  }
  const Comp = as || "button";
  return (
    <Comp className={classes} {...rest}>
      {children}
    </Comp>
  );
}
